// extracted by mini-css-extract-plugin
export default {"mouseIcon":"index_mouseIcon__wKgOK"};